import {
  ArchiveIcon,
  BarcodeIcon,
  BasketIcon,
  BiohazardIcon,
  BookOpenIcon,
  BooksIcon,
  BowlFoodIcon,
  BugIcon,
  BuildingsIcon,
  CalendarCheckIcon,
  BirdIcon,
  CarrotIcon,
  ChartBarIcon,
  ChartLineIcon,
  CheckCircleIcon,
  ClipboardTextIcon,
  ClockIcon,
  CowIcon,
  DatabaseIcon,
  DnaIcon,
  DogIcon,
  DropIcon,
  FactoryIcon,
  FarmIcon,
  FileTextIcon,
  FishIcon,
  FlaskIcon,
  FlowerIcon,
  FolderIcon,
  ForkKnifeIcon,
  GlobeIcon,
  GraphIcon,
  HandshakeIcon,
  HeartbeatIcon,
  HouseLineIcon,
  LeafIcon,
  ListChecksIcon,
  MagnifyingGlassIcon,
  MapPinIcon,
  MapTrifoldIcon,
  MedalIcon,
  MicroscopeIcon,
  NotebookIcon,
  PackageIcon,
  PawPrintIcon,
  PillIcon,
  PlantIcon,
  ScalesIcon,
  ShieldCheckIcon,
  SirenIcon,
  SparkleIcon,
  StethoscopeIcon,
  StrategyIcon,
  TargetIcon,
  TestTubeIcon,
  ThermometerIcon,
  TreeIcon,
  TreeStructureIcon,
  TruckIcon,
  UserIcon,
  UsersIcon,
  VirusIcon,
  WarningIcon,
  WavesIcon,
  type Icon
} from 'prove-common'

export type PlanIconId =
  | 'standard'
  | 'animal'
  | 'health'
  | 'fish'
  | 'chemistry'
  | 'plant'
  | 'leaf'
  | 'virus'
  | 'archive'
  | 'barcode'
  | 'basket'
  | 'bookOpen'
  | 'books'
  | 'bowlFood'
  | 'bug'
  | 'buildings'
  | 'biohazard'
  | 'calendarCheck'
  | 'bird'
  | 'carrot'
  | 'chartBar'
  | 'chartLine'
  | 'checkCircle'
  | 'clipboardText'
  | 'clock'
  | 'cow'
  | 'database'
  | 'dna'
  | 'dog'
  | 'drop'
  | 'factory'
  | 'farm'
  | 'fileText'
  | 'flower'
  | 'forkKnife'
  | 'globe'
  | 'graph'
  | 'handshake'
  | 'heartbeat'
  | 'houseLine'
  | 'listChecks'
  | 'magnifyingGlass'
  | 'mapPin'
  | 'mapTrifold'
  | 'medal'
  | 'microscope'
  | 'notebook'
  | 'package'
  | 'pill'
  | 'scales'
  | 'shieldCheck'
  | 'siren'
  | 'sparkle'
  | 'strategy'
  | 'target'
  | 'testTube'
  | 'thermometer'
  | 'tree'
  | 'treeStructure'
  | 'truck'
  | 'user'
  | 'users'
  | 'warning'
  | 'waves'

type PlanIconOption = {
  id: PlanIconId
  label: string
  icon: Icon
}

const PLAN_ICON_STORAGE_KEY = 'localSettings.proveplan.planIcons'

export const planIconOptions: PlanIconOption[] = [
  { id: 'standard', label: 'Standard', icon: FolderIcon },
  { id: 'animal', label: 'Landdyr', icon: PawPrintIcon },
  { id: 'health', label: 'Dyrehelse', icon: StethoscopeIcon },
  { id: 'fish', label: 'Fiskehelse', icon: FishIcon },
  { id: 'chemistry', label: 'Kjemi', icon: FlaskIcon },
  { id: 'plant', label: 'Planter', icon: PlantIcon },
  { id: 'leaf', label: 'Blad', icon: LeafIcon },
  { id: 'virus', label: 'Virus', icon: VirusIcon },
  { id: 'archive', label: 'Arkiv', icon: ArchiveIcon },
  { id: 'barcode', label: 'Strekkode', icon: BarcodeIcon },
  { id: 'basket', label: 'Kurv', icon: BasketIcon },
  { id: 'bookOpen', label: 'Veileder', icon: BookOpenIcon },
  { id: 'books', label: 'Bibliotek', icon: BooksIcon },
  { id: 'bowlFood', label: 'Mat', icon: BowlFoodIcon },
  { id: 'bug', label: 'Skadedyr', icon: BugIcon },
  { id: 'buildings', label: 'Virksomhet', icon: BuildingsIcon },
  { id: 'biohazard', label: 'Biofare', icon: BiohazardIcon },
  { id: 'calendarCheck', label: 'Frist', icon: CalendarCheckIcon },
  { id: 'bird', label: 'Fugl', icon: BirdIcon },
  { id: 'carrot', label: 'Gulrot', icon: CarrotIcon },
  { id: 'chartBar', label: 'Statistikk', icon: ChartBarIcon },
  { id: 'chartLine', label: 'Trend', icon: ChartLineIcon },
  { id: 'checkCircle', label: 'Godkjent', icon: CheckCircleIcon },
  { id: 'clipboardText', label: 'Sjekkliste', icon: ClipboardTextIcon },
  { id: 'clock', label: 'Tid', icon: ClockIcon },
  { id: 'cow', label: 'Husdyr', icon: CowIcon },
  { id: 'database', label: 'Data', icon: DatabaseIcon },
  { id: 'dna', label: 'DNA', icon: DnaIcon },
  { id: 'dog', label: 'Hund', icon: DogIcon },
  { id: 'drop', label: 'Vannkvalitet', icon: DropIcon },
  { id: 'factory', label: 'Produksjon', icon: FactoryIcon },
  { id: 'farm', label: 'Landbruk', icon: FarmIcon },
  { id: 'fileText', label: 'Dokument', icon: FileTextIcon },
  { id: 'flower', label: 'Blomst', icon: FlowerIcon },
  { id: 'forkKnife', label: 'Servering', icon: ForkKnifeIcon },
  { id: 'globe', label: 'Import', icon: GlobeIcon },
  { id: 'graph', label: 'Analyse', icon: GraphIcon },
  { id: 'handshake', label: 'Avtale', icon: HandshakeIcon },
  { id: 'heartbeat', label: 'Helse', icon: HeartbeatIcon },
  { id: 'houseLine', label: 'Lokasjon', icon: HouseLineIcon },
  { id: 'listChecks', label: 'Oppgaver', icon: ListChecksIcon },
  { id: 'magnifyingGlass', label: 'Tilsyn', icon: MagnifyingGlassIcon },
  { id: 'mapPin', label: 'Kartpunkt', icon: MapPinIcon },
  { id: 'mapTrifold', label: 'Kart', icon: MapTrifoldIcon },
  { id: 'medal', label: 'Prioritert', icon: MedalIcon },
  { id: 'microscope', label: 'Mikroskop', icon: MicroscopeIcon },
  { id: 'notebook', label: 'Notat', icon: NotebookIcon },
  { id: 'package', label: 'Pakke', icon: PackageIcon },
  { id: 'pill', label: 'Medisin', icon: PillIcon },
  { id: 'scales', label: 'Regelverk', icon: ScalesIcon },
  { id: 'shieldCheck', label: 'Trygghet', icon: ShieldCheckIcon },
  { id: 'siren', label: 'Varsel', icon: SirenIcon },
  { id: 'sparkle', label: 'Kvalitet', icon: SparkleIcon },
  { id: 'strategy', label: 'Strategi', icon: StrategyIcon },
  { id: 'target', label: 'Mal', icon: TargetIcon },
  { id: 'testTube', label: 'Prøve', icon: TestTubeIcon },
  { id: 'thermometer', label: 'Temperatur', icon: ThermometerIcon },
  { id: 'tree', label: 'Tre', icon: TreeIcon },
  { id: 'treeStructure', label: 'Hierarki', icon: TreeStructureIcon },
  { id: 'truck', label: 'Transport', icon: TruckIcon },
  { id: 'user', label: 'Ansvarlig', icon: UserIcon },
  { id: 'users', label: 'Team', icon: UsersIcon },
  { id: 'warning', label: 'Advarsel', icon: WarningIcon },
  { id: 'waves', label: 'Vann', icon: WavesIcon }
]

const parseStoredPlanIcons = (): Record<string, PlanIconId> => {
  try {
    const stored = localStorage.getItem(PLAN_ICON_STORAGE_KEY)
    if (!stored) return {}
    const parsed = JSON.parse(stored) as Record<string, PlanIconId>
    const validIds = new Set(planIconOptions.map(({ id }) => id))

    return Object.fromEntries(
      Object.entries(parsed).filter(([, iconId]) => validIds.has(iconId))
    )
  } catch {
    return {}
  }
}

export const getPlanIconId = (planId: number): PlanIconId =>
  parseStoredPlanIcons()[planId.toString()] ?? 'standard'

export const setPlanIconId = (planId: number, iconId: PlanIconId) => {
  localStorage.setItem(
    PLAN_ICON_STORAGE_KEY,
    JSON.stringify({
      ...parseStoredPlanIcons(),
      [planId.toString()]: iconId
    })
  )
}

export const getPlanIconOption = (iconId: PlanIconId) =>
  planIconOptions.find((option) => option.id === iconId) ?? planIconOptions[0]
